export default __webpack_public_path__ + "static/media/navbar-circle-toggle.9441149c.png";